import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$contact = new Vue({
  methods: {
    get(language = "en") {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      const url = `${getBaseUrl()}contacts/${lang}`;

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },

    jobs(language = "en", office) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      let url = `${getBaseUrl()}vacancies/${lang}`;

      if (office) {
        url += `?office=${office}`;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
